export const SET_GALLERY = "SET_GALLERY";
export const GET_GALLERY = "GET_GALLERY";
export const DELETE_GALLERY = "DELETE_GALLERY";
export const UPDATE_GALLERY = "UPDATE_GALLERY";